import { render, staticRenderFns } from "./tiposDocumentos.vue?vue&type=template&id=470480ba&"
import script from "./tiposDocumentos.vue?vue&type=script&lang=js&"
export * from "./tiposDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./tiposDocumentos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports